import { ToolBase, ToolDescription } from "../../../agents/base";
import { createTelemetry, resolveSessionId, unwrapRequest, } from "../readHelpers";
import { ListSheetsParamsSchema } from "./listSheets.schema";
const SYSTEM_PROMPT_DESCRIPTION = `### listSheets
List workbook worksheets and their positions.

Use this tool when you need available sheet names before read/edit operations.`;
export function createListSheetsTool(runner, fallbackSessionId) {
    return new ListSheetsTool(runner, fallbackSessionId).toRuntimeToolDefinition();
}
export class ListSheetsTool extends ToolBase {
    constructor(runner, fallbackSessionId) {
        super();
        this.runner = runner;
        this.fallbackSessionId = fallbackSessionId;
        this.name = "listSheets";
        this.description = new ToolDescription("listSheets", "List workbook worksheets and positions.", ListSheetsParamsSchema);
        this.paramsSchema = ListSheetsParamsSchema;
        this.systemPromptDescription = SYSTEM_PROMPT_DESCRIPTION;
    }
    setSessionId(sessionId) {
        this.fallbackSessionId = sessionId;
    }
    async execute(args) {
        const startedAt = Date.now();
        const sessionId = resolveSessionId(args, this.fallbackSessionId);
        const request = unwrapRequest(args);
        const listSheets = request.listSheets?.length ? request.listSheets : [{}];
        const result = await this.runner.read({ listSheets }, { sessionId });
        const payload = (result.data || {});
        const listSheetsResult = payload.listSheets || [];
        return {
            ...result,
            data: { listSheets: listSheetsResult },
            results: { listSheets: listSheetsResult },
            telemetry: result.telemetry || createTelemetry(listSheets.length, startedAt),
        };
    }
}
